// extracted by mini-css-extract-plugin
export var copyright = "Footer-module--copyright--d8645";
export var icons = "Footer-module--icons--0a4f0";
export var navigation = "Footer-module--navigation--74d23";
export var navitem = "Footer-module--navitem--20797";
export var wrapper = "Footer-module--wrapper--4e863";